import React from "react"
import { PortfolioItem, PortfolioItemReveresed} from "./portfolioItem"

const Portfolio = () => (
    <section className="container relative z-20 py-8" id="portfolio">
        <h1 className="text-4xl font-extrabold">My Portfolio</h1>
        <h3 className="text-2xl font-bold">Amazing work for Amazing clients</h3>
        <PortfolioItem 
            ProjectTitle="Khaled Elbalal's Personal Website"
            ProjectDesc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu est in enim luctus lobortis. Fusce id odio fermentum purus pulvinar ornare. Praesent laoreet nisi id facilisis congue. Integer in nunc nec mauris lacinia vestibulum in in ligula. Sed mattis mauris lorem, vitae varius dui scelerisque non. Nunc maximus sem a orci tempor, sed dignissim tellus bibendum. Integer a augue nec nunc ultricies accumsan."
            ProjectType="Web Design"
            ProjectImg="site1.webp"
            ProjectImgAlt="site1.png"
            ProjectLink="https://www.khaledelbalal.me/"
        />
        <PortfolioItemReveresed
            ProjectTitle="Khaled Elbalal's Personal Website"
            ProjectDesc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu est in enim luctus lobortis. Fusce id odio fermentum purus pulvinar ornare. Praesent laoreet nisi id facilisis congue. Integer in nunc nec mauris lacinia vestibulum in in ligula. Sed mattis mauris lorem, vitae varius dui scelerisque non. Nunc maximus sem a orci tempor, sed dignissim tellus bibendum. Integer a augue nec nunc ultricies accumsan."
            ProjectType="Web Design"
            ProjectImg="site1.webp"
            ProjectImgAlt="site1.png"
            ProjectLink="https://www.khaledelbalal.me/"
        />
        <PortfolioItem 
            ProjectTitle="Khaled Elbalal's Personal Website"
            ProjectDesc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu est in enim luctus lobortis. Fusce id odio fermentum purus pulvinar ornare. Praesent laoreet nisi id facilisis congue. Integer in nunc nec mauris lacinia vestibulum in in ligula. Sed mattis mauris lorem, vitae varius dui scelerisque non. Nunc maximus sem a orci tempor, sed dignissim tellus bibendum. Integer a augue nec nunc ultricies accumsan."
            ProjectType="Web Design"
            ProjectImg="site1.webp"
            ProjectImgAlt="site1.png"
            ProjectLink="https://www.khaledelbalal.me/"
            Children={<div className="absolute top-0 right-0 z-0 origin-bottom-right transform rotate-45 shadow-2xl box">&nbsp;</div>}
        >
        </PortfolioItem>
    </section>
)

export default Portfolio